import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const {
    t
  } = useLanguage();
  const faqs = [{
    q: t('faq.q1'),
    a: t('faq.a1')
  }, {
    q: t('faq.q2'),
    a: t('faq.a2')
  }, {
    q: t('faq.q3'),
    a: t('faq.a3')
  }, {
    q: t('faq.q4'),
    a: t('faq.a4')
  }, {
    q: t('faq.q5'),
    a: t('faq.a5')
  }, {
    q: t('faq.q6'),
    a: t('faq.a6')
  }];
  return <section id="faq" className="py-12 md:py-24 bg-brand-white relative" data-id="element-62" data-mp="21sq2f9gnaszp">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-63" data-mp="26rt18c6182z8">
        <div className="text-center mb-10 md:mb-16" data-id="element-64" data-mp="2uiyhgsfvwxa2">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-65" data-mp="2uhdi8pimkq5v">
            <h2 className="text-3xl md:text-4xl font-serif text-brand-brown mb-4 md:mb-6" data-id="element-66" data-mp="25fughwv8xv1m">
              {t('faq.title')}
            </h2>
            <div className="w-24 h-1 bg-brand-gold mx-auto rounded-full" data-id="element-67" data-mp="20njaqddtrf15"></div>
          </motion.div>
        </div>

        <div className="space-y-4" data-id="element-68" data-mp="2fflalxfwa816">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="border border-brand-gold/20 rounded-sm overflow-hidden bg-white" data-id="element-69" data-mp="2aee1nv20n2sx" data-mpi={index}>
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none hover:bg-brand-cream/50 transition-colors" data-id="element-70" data-mp="2u2negfhhptsb">
                <span className="font-medium text-brand-charcoal pr-8" data-id="element-71" data-mp="334oaxa4wgbsx">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-gold transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-72" data-mp="380lq3d4ffc44" />
              </button>

              <AnimatePresence data-id="element-73" data-mp="3mr2rwxkz441j">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-74" data-mp="3mtf9h9mtkce2">
                    <div className="px-6 pb-5 text-gray-600 border-t border-brand-gold/10 pt-4" data-id="element-75" data-mp="164w29vsz0sz4">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}